<formio-loader></formio-loader>
<div class="grouped-table-wrapper">
    <form #form="ngForm">
        <ng-container *ngIf="tableData && tableData.length">
            <p-table [value]="tableData" sortField="tableConfig.rowGroup" sortMode="single" (onSort)="onSort()">
                <ng-template pTemplate="header">
                    <tr *ngFor="let row of headerRows">
                        <th *ngFor="let headerRow of row" [style.width]="headerRow.width"
                            [attr.rowspan]="headerRow.rowSpan" [attr.colspan]="headerRow.colSpan">
                            <div class="{{headerRow.class}}" *ngIf="headerRow.name">
                                {{'forms.common.' + headerRow.name | translate}}
                                <ng-container *ngIf="headerRow.nameExtraString">
                                    {{headerRow.nameExtraString}}
                                </ng-container>
                            </div>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
                    <tr>
                        <ng-container *ngFor="let colKey of colsKeys">
                            <td *ngIf="rowGroupMetadata[item[tableConfig.rowGroup]].index == rowIndex && colKey.key == tableConfig.rowGroup;else noGrouped"
                                [attr.rowspan]="rowGroupMetadata[item[tableConfig.rowGroup]].size"
                                class=" {{colKey.class}}">
                                <div [innerHTML]="item[colKey.key] | safeHtml"></div>
                            </td>
                            <ng-template #noGrouped>
                                <ng-container *ngIf="colKey.key != tableConfig.rowGroup">
                                    <ng-container *ngIf="tableConfig.rows[rowIndex];else normalRow">
                                        <td class="{{tableConfig.rows[rowIndex].class}} {{colKey.class}}">
                                            <div
                                                *ngIf="tableConfig.rows[rowIndex].type == 'total' && colKey.editable;else normal">
                                                {{item | calculatedRowTotal : tableData : 0 : rowIndex : colKey.key}}
                                            </div>
                                            <ng-template #normal>
                                                <div
                                                    *ngIf="tableConfig.rows[rowIndex].type == 'ratio' && colKey.editable; else emptyOrCalculated">
                                                    {{item | calculatedRowRatio : tableData :
                                                    tableConfig.rows[rowIndex].firstFiled :
                                                    tableConfig.rows[rowIndex].secondFiled : colKey.key}}
                                                </div>
                                                <ng-template #emptyOrCalculated>
                                                    <div
                                                        [innerHTML]="(item[colKey.key] ? item[colKey.key] : '-') | safeHtml">
                                                    </div>
                                                </ng-template>
                                            </ng-template>
                                        </td>
                                    </ng-container>
                                    <ng-template #normalRow>
                                        <ng-container *ngIf="colKey.editable && !viewOnly;else display">
                                            <td>
                                                <div class="{{colKey.editable?.percentage ? 'percentage' : ''}}">
                                                    <span *ngIf="colKey.editable.percentage">%</span>
                                                    <input type="{{colKey.editable.type}}"
                                                        required="{{colKey.editable.required}}"
                                                        pattern="{{colKey.editable.pattern}}"
                                                        min="{{colKey.editable.min}}" max="{{colKey.editable.max}}"
                                                        step="{{colKey.editable.percentage ? 0.01 : 1}}"
                                                        minlength="{{colKey.editable.minlength}}"
                                                        maxlength="{{colKey.editable.maxlength}}"
                                                        [(ngModel)]="item[colKey.key]"
                                                        name="{{rowIndex}}_{{colKey.key}}"
                                                        oninput="validity.valid||(value='');" />
                                                </div>
                                            </td>
                                        </ng-container>
                                        <ng-template #display>
                                            <td
                                                class="{{item[colKey.key] || colKey.total || colKey.ratio ? '' : 'noData'}} {{colKey.class}}">
                                                <div *ngIf="colKey.total;else normal">
                                                    {{item | calculatedTotal : colKey.total : colKey.key}}
                                                </div>
                                                <ng-template #normal>
                                                    <div *ngIf="colKey.ratio; else emptyOrCalculated">
                                                        {{item | calculatedRatio : colKey.ratio.firstFiled :
                                                        colKey.ratio.secondFiled : colKey.key}}
                                                    </div>
                                                    <ng-template #emptyOrCalculated>
                                                        <div
                                                            [innerHTML]="(item[colKey.key] ? item[colKey.key] : '-') | safeHtml">
                                                        </div>
                                                    </ng-template>
                                                </ng-template>
                                            </td>
                                        </ng-template>
                                    </ng-template>
                                </ng-container>
                            </ng-template>
                        </ng-container>
                    </tr>
                </ng-template>
            </p-table>
        </ng-container>

        <div *ngIf="saveControl">
            <br />

            <label class="control-label {{isNotesRequired ? 'field-required' : ''}}">{{'forms.common.statisticalNotes' | translate}}</label>
            <textarea class="form-control" [(ngModel)]="notes" [disabled]="viewOnly" rows="4" name="notes"
                [required]="isNotesRequired"></textarea>

            <div class="form-actions {{ customOptions?.save?.isCenter ? 'center': ''}}" *ngIf="!viewOnly">
                <button type="button" class="btn btn-primary btn-md" [disabled]="!form.form.valid"
                    (click)="saveControl.justNotes ? onSaveNotes() : onSaveMap()">
                    <ng-container *ngIf="customOptions?.save?.name;else normal">
                        {{customOptions.save.name | translate}}
                    </ng-container>
                    <ng-template #normal>
                        {{'forms.common.Save' | translate}}
                    </ng-template>
                </button>
            </div>
        </div>
    </form>
</div>